import { useBreadcrumb } from "features/breadcrumbs";
import { Flex } from "@chakra-ui/layout";
import Heading from "components/text/heading";
import { Col, Row } from "antd";
import FormQuestoes from "./components/FormQuestoes";
import { useLocation, useRouteMatch } from "react-router";
import useAssembleia from "features/assembleia/hooks/useAssembleia";
import CardDefault from "components/Cards/CardDefault";
import useSaveAssembleia from "features/assembleia/hooks/useSaveAsssembleia";
import { showErrorAxios, showSuccess } from "infra/helpers/alerta";
import history from "infra/helpers/history";
import { TabsDetalheAssembleiaRoutes } from "./typings";
import { useState } from "react";
import ListaProcuracoes from "./components/ListaProcuracoes";
import AssembleiaResultado from "./components/Resultado";
import AssembleiaParticipantes from "./components/Participantes";
import RelatoriosParticipantes from "./components/Relatorios";
import VideoConferencia from "./components/VideoConferencia";
import { useLoading } from "components/GlobalLoading";
import { useWindowSize } from "infra/helpers/window";
import { Button } from "@chakra-ui/react";
import { Drawer } from "antd";
import MenuDetalhesRoute from "./components/MenuDetalhesRoute/index";
import { MenuOutlined } from "@ant-design/icons";
import Container from "components/Container";

function AssembleiaDetalhesPage() {
  const route = useRouteMatch<{ id: string }>();

  const { data, isLoading, isFetching, refetch } = useAssembleia(
    route.params.id
  );
  const { mutate: handleSave, isLoading: isLoadingSave } = useSaveAssembleia(
    route.params.id
  );

  const { search } = useLocation();

  const params = new URLSearchParams(search);
  const opcaoParam = !route.params.id
    ? TabsDetalheAssembleiaRoutes.Editar
    : (params.get("opcao") as string) || TabsDetalheAssembleiaRoutes.Editar;

  const [selectedMenuOption, setSelectedMenuOption] = useState(opcaoParam);

  const windowSize = useWindowSize();

  const isMobile = windowSize.width <= 800;
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleChangeMenu = (tab: string) => {
    setSelectedMenuOption(tab);

    if (route.params.id) {
      history.push(
        `/administracao/assembleias/${route.params.id}?opcao=${tab}`
      );
    } else {
      history.push(`/administracao/assembleias/criar?opcao=${tab}`);
    }
  };

  useBreadcrumb([
    { name: "Votações", url: "/administracao/assembleias" },
    {
      name: route.params.id ? data?.nome || "Votação" : "Nova Votação",
      url: `/administracao/assembleias/${
        route.params.id || "criar"
      }?opcao=${selectedMenuOption}`,
    },
  ]);

  useLoading(isLoading || isFetching);

  return (
    <Container pb={4}>
      <Flex mb="16px">
        <Heading>{data?.nome || "Votação"}</Heading>
      </Flex>

      {isMobile ? (
        <Flex>
          <Button
            onClick={() => setMobileMenuOpen((state) => !state)}
            bg="white"
            mb={4}
          >
            {isMobile ? <MenuOutlined size={20} /> : null}
          </Button>
        </Flex>
      ) : null}

      <Drawer
        width={windowSize.width * 0.8}
        onClose={() => setMobileMenuOpen(false)}
        closeIcon={false}
        visible={mobileMenuOpen}
        bodyStyle={{ padding: 0 }}
        placement="left"
        extra={
          <Flex>
            <Button onClick={() => setMobileMenuOpen(false)}>Fechar</Button>
          </Flex>
        }
      >
        <MenuDetalhesRoute
          data={data}
          handleChangeMenu={(tab) => {
            handleChangeMenu(tab);
            setMobileMenuOpen(false);
          }}
          route={route}
          selectedMenuOption={selectedMenuOption}
          shadow={false}
          rounded={false}
        />
      </Drawer>

      <Row gutter={16}>
        <Col sm={isMobile ? 0 : 5} className="hidden-print">
          <MenuDetalhesRoute
            data={data}
            handleChangeMenu={handleChangeMenu}
            route={route}
            selectedMenuOption={selectedMenuOption}
          />
        </Col>

        <Col sm={isMobile ? 24 : 19}>
          {selectedMenuOption === TabsDetalheAssembleiaRoutes.Editar ? (
            <CardDefault>
              <FormQuestoes
                isLoading={isLoadingSave || isLoading}
                onSubmit={(v) =>
                  handleSave(v, {
                    onError: (e) => {
                      showErrorAxios(e);
                    },
                    onSuccess: ({ id }) => {
                      showSuccess().then(() => {
                        if (route.params.id) {
                          refetch();
                        }
                        history.push(`/administracao/assembleias/${id}`);
                      });
                    },
                  })
                }
                value={data as any}
              />
            </CardDefault>
          ) : null}

          {selectedMenuOption === TabsDetalheAssembleiaRoutes.Procuracoes &&
          route.params.id ? (
            <ListaProcuracoes idAssembleia={route.params.id} />
          ) : null}

          {selectedMenuOption === TabsDetalheAssembleiaRoutes.Resultado &&
          route.params.id ? (
            <AssembleiaResultado idAssembleia={route.params.id} />
          ) : null}

          {selectedMenuOption === TabsDetalheAssembleiaRoutes.Participantes &&
          route.params.id ? (
            <AssembleiaParticipantes idAssembleia={route.params.id} />
          ) : null}

          {selectedMenuOption === TabsDetalheAssembleiaRoutes.Video &&
          !!data?.webinarId &&
          route.params.id ? (
            <VideoConferencia idAssembleia={route.params.id} />
          ) : null}

          {selectedMenuOption === TabsDetalheAssembleiaRoutes.Relatorio &&
          route.params.id ? (
            <RelatoriosParticipantes idAssembleia={route.params.id} />
          ) : null}
        </Col>
      </Row>

      {/* {data?.webinarId ? (
        <Chat
          firebaseCollectionPath={`video-conferencia/${route.params.id}/mensagens-chat`}
          votacaoId={data.id}
        />
      ) : null} */}
    </Container>
  );
}

export default AssembleiaDetalhesPage;
